module.exports = __webpack_public_path__ + "static/media/veggie.b61b5d4c.jpg";